module.exports = __webpack_public_path__ + "static/media/Socios.29b6e40e.svg";